export default __webpack_public_path__ + "static/media/ActivityInformationAndConsentForm.b0c6854b.pdf";